// Sentry must be imported FIRST so its instrumentation is in place before
// any other module registers an error handler. No-op when
// REACT_APP_SENTRY_DSN is unset.
import "@/lib/sentry";
// Initialise Meta Pixel as early as possible so the very first
// PageView lands on time. No-op when REACT_APP_META_PIXEL_ID is unset.
import { initMetaPixel } from "@/lib/metaPixel";
initMetaPixel();

import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"), {
  // React 19 error hooks → Sentry. Safe even when Sentry isn't initialized
  // (reactErrorHandler returns a noop callback in that case).
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
});
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
